"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearBookingItemAvailability = exports.clearBookings = exports.clearBooking = exports.clearHistoryPayment = exports.BookingsSlice = exports.bookingsInitialState = void 0;
const tslib_1 = require("tslib");
const index_1 = require("./../../actions/saas/bookings/getItemAvailability/index");
const index_2 = require("./../../actions/saas/bookings/getAllItemsAvailability/index");
const updateBookingServices_1 = require("../../actions/bookings/updateBookingServices");
const index_3 = require("../../actions/saas/bookings/updateItems/index");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getHistoryPayment_1 = require("../../actions/bookings/getHistoryPayment");
const getById_1 = require("../../actions/saas/bookings/getById");
const updateBookingTaxesDefault_1 = require("../../actions/bookings/updateBookingTaxesDefault");
const updateBookingNotes_1 = require("../../actions/bookings/updateBookingNotes");
const enableInsurance_1 = require("../../actions/saas/insurances/enableInsurance");
const updateDates_1 = require("../../actions/saas/bookings/updateDates");
const updateCustomer_1 = require("../../actions/saas/bookings/updateCustomer");
const updatePickup_1 = require("../../actions/saas/bookings/updatePickup");
const updateReturn_1 = require("../../actions/saas/bookings/updateReturn");
const getAll_1 = require("../../actions/saas/insurances/getAll");
const refreshBooking_1 = require("../../actions/saas/bookings/refreshBooking");
const resetItemPrices_1 = require("../../actions/saas/bookings/resetItemPrices");
const updateBookingItemPrice_1 = require("../../actions/saas/bookings/updateBookingItemPrice");
const resetItemQuantity_1 = require("../../actions/saas/bookings/resetItemQuantity");
const getById_2 = require("../../actions/flecto-link/getById");
exports.bookingsInitialState = {
    booking: {
        data: null,
        loading: false,
        slices: {
            items: {
                loading: false,
                error: false,
            },
            dates: {
                loading: false,
                error: false,
            },
            services: {
                loading: false,
                error: false,
            },
            notes: {
                loading: false,
                error: false,
            },
            availability: {
                data: [],
                loading: false,
            },
            insurances: {
                data: [],
                meta: {},
                error: false,
                loading: false,
            },
        },
    },
    bookings: {
        loading: false,
        data: [],
    },
    createBooking: {
        historyPayments: {
            loading: false,
            data: [],
        },
    },
};
const combineExtraReducers = (builder) => {
    (0, getHistoryPayment_1.getHistoryPaymentExtraReducers)(builder);
    (0, getById_1.getBookingByIdExtraReducers)(builder);
    (0, updateDates_1.updateBookingDatesExtraReducers)(builder);
    (0, updateCustomer_1.updateBookingCustomerExtraReducers)(builder);
    (0, index_3.updateBookingItemsExtraReducers)(builder);
    (0, updateBookingServices_1.updateBookingServicesExtraReducers)(builder);
    (0, updateBookingTaxesDefault_1.updateBookingTaxesDefaultExtraReducers)(builder);
    (0, updateBookingNotes_1.updateBookingNotesExtraReducers)(builder);
    (0, enableInsurance_1.enableBookingInsuranceExtraReducers)(builder);
    (0, updatePickup_1.updateBookingPickupItemsExtraReducers)(builder);
    (0, updateReturn_1.updateBookingReturnItemsExtraReducers)(builder);
    (0, getAll_1.getAllBookingInsurancesExtraReducers)(builder);
    (0, refreshBooking_1.refreshBookingByIdExtraReducers)(builder);
    (0, resetItemPrices_1.resetBookingItemsPriceExtraReducers)(builder);
    (0, index_2.getAllBookingItemAvailabilityExtraReducers)(builder);
    (0, index_1.getBookingItemAvailabilityExtraReducers)(builder);
    (0, updateBookingItemPrice_1.updateBookingItemPriceExtraReducers)(builder);
    (0, resetItemQuantity_1.resetBookingItemQuantityExtraReducers)(builder);
    (0, getById_2.getBookingByPermalinkExtraReducers)(builder);
};
exports.BookingsSlice = toolkitRaw.createSlice({
    name: 'bookings',
    initialState: exports.bookingsInitialState,
    reducers: {
        clearHistoryPayment: (state) => {
            state.createBooking.historyPayments.data = [];
        },
        clearBooking: (state) => {
            state.createBooking.historyPayments.data = [];
            state.booking.data = null;
            state.booking.slices.insurances.data = [];
            state.booking.slices.insurances.meta = {};
        },
        clearBookings: (state) => {
            state.bookings.data = [];
        },
        clearBookingItemAvailability: (state) => {
            state.booking.slices.availability.data = [];
        },
    },
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
_a = exports.BookingsSlice.actions, exports.clearHistoryPayment = _a.clearHistoryPayment, exports.clearBooking = _a.clearBooking, exports.clearBookings = _a.clearBookings, exports.clearBookingItemAvailability = _a.clearBookingItemAvailability;
exports.default = exports.BookingsSlice.reducer;
//# sourceMappingURL=index.js.map